import React from 'react';
import Translate from '@src/components/Translate/Translate';
import {formatPrice} from '@src/helpers/formatters/prices/formatPrice';
import {OrderTotalProductsPrice} from '@views/orders/fields/products/OrderTotalProductsPrice';
import useFormValue from '@src/hooks/useFormValue';
import {IOrderModel} from '@src/@interfaces/models/Order/IOrderModel';
import {IOrderProductModel} from '@src/@interfaces/models/Order/IOrderProductModel';

export function TableCaption({options}: { options?: Record<string, any> }) {
    const {currentValue: products} = useFormValue<IOrderModel, IOrderProductModel[] | undefined>('products');

    return <OrderTotalProductsPrice
            products={products}
            modelOptions={options}
    >{totalPrice => {
        return <Translate
                message="OrderForm.products.total_price_is"
                replace={{
                    price: totalPrice,
                    formattedPrice: formatPrice(totalPrice)
                }}
                tag="caption"
                className="px-2"
        />;
    }}</OrderTotalProductsPrice>;
}
